import { IUpdateUsersParams } from 'src/redux/mira-sleep-user';
import BaseRequest, { IPagination } from './BaseRequest';

export default class AuthRequest extends BaseRequest {
  getUsers(payload: IPagination) {
    const url = '/web/users';
    return this.get(url, payload);
  }

  updateUsers(payload: IUpdateUsersParams[]) {
    const url = '/web/users/update-community';
    return this.put(url, payload);
  }
}
